module.exports = __webpack_public_path__ + "media/images/emblems/Zell_LU-a5579d0585477cecc32521d44662d3ee.png";